import {BaseConverter} from '../../base/converters/base-converter.converter';
import {ProductTypeModel} from '../models/product-type.model';
import {ProductType} from '../../shared/DTO/productType';
import {ServiceConverter} from './service.converter';
import {ServicesCombinationConverter} from './service-combination.converter';
import {Injectable} from '@angular/core';

@Injectable()
export class ProductTypeConverter extends BaseConverter<ProductTypeModel, ProductType> {

  constructor(private serviceConverter: ServiceConverter, private servicesCombinationConverter: ServicesCombinationConverter) {
    super();
  }

  convertToDto(model: ProductTypeModel): ProductType {
    if (!model) {
      return;
    }
    return {
      article: model.article,
      services: this.serviceConverter.convertToDtoList(model.services),
      servicesCombinations: this.servicesCombinationConverter.convertToDtoList(model.servicesCombinations),
      type: model.type
    };
  }

  convertToModel(dto: ProductType): ProductTypeModel {
    if (!dto) {
      return null;
    }
    let model: ProductTypeModel = new ProductTypeModel();
    model.article = dto.article;
    model.services = this.serviceConverter.convertToModelList(dto.services);
    model.servicesCombinations = this.servicesCombinationConverter.convertToModelList(dto.servicesCombinations);
    model.type = dto.type;
    return model;
  }

}
